module.exports = __webpack_public_path__ + "img/USP_Icons-European-excellence.b6b0776.png";